import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import Footer from 'components/footer/Footer';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import ProtectedRoute from 'components/ProtectedRoute';
import PMSNavbarTop from 'components/navbar/top/PMSNavbarTop';

import { useAppContext } from 'providers/AppProvider';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');

  const {
    config: { isFluid }
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, [hash]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ProtectedRoute>
      <div className={isFluid ? 'container-fluid' : 'container'}>
        <PMSNavbarTop />
        <div className={classNames('content', { 'pb-0': isKanban })}>
          {/*------ Main Routes ------*/}
          <Outlet />
          {!isKanban && <Footer />}
        </div>
        <ModalAuth />
      </div>
    </ProtectedRoute>
  );
};

export default MainLayout;
